import { render, staticRenderFns } from "./CataloguesDash.vue?vue&type=template&id=76da78bc"
import script from "./CataloguesDash.vue?vue&type=script&lang=js"
export * from "./CataloguesDash.vue?vue&type=script&lang=js"
import style0 from "./CataloguesDash.vue?vue&type=style&index=0&id=76da78bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports